/**
 * @generated SignedSource<<6856d5cc28b80b5c1504a300538b4598>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type TodoEditMoveToCategoryMutation$variables = {
  employeeId?: string | null;
  newCategoryId: string;
  todoId: string;
};
export type TodoEditMoveToCategoryMutation$data = {
  readonly todo: {
    readonly moveToCategory: {
      readonly todo: {
        readonly category: {
          readonly tags: ReadonlyArray<{
            readonly color: string;
            readonly id: string;
            readonly title: string;
          }>;
        } | null;
        readonly categoryId: string;
        readonly tags: ReadonlyArray<{
          readonly color: string;
          readonly id: string;
          readonly title: string;
        }>;
      };
    };
  } | null;
};
export type TodoEditMoveToCategoryMutation = {
  response: TodoEditMoveToCategoryMutation$data;
  variables: TodoEditMoveToCategoryMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "employeeId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "newCategoryId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "todoId"
},
v3 = [
  {
    "kind": "Variable",
    "name": "employeeId",
    "variableName": "employeeId"
  },
  {
    "kind": "Variable",
    "name": "todoId",
    "variableName": "todoId"
  }
],
v4 = [
  {
    "kind": "Variable",
    "name": "newCategoryId",
    "variableName": "newCategoryId"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "categoryId",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "TodoCategoryTag",
  "kind": "LinkedField",
  "name": "tags",
  "plural": true,
  "selections": [
    (v6/*: any*/),
    (v7/*: any*/),
    (v8/*: any*/)
  ],
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "TodoCategoryTag",
  "kind": "LinkedField",
  "name": "tags",
  "plural": true,
  "selections": [
    (v7/*: any*/),
    (v6/*: any*/),
    (v8/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "TodoEditMoveToCategoryMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "TodoMutation",
        "kind": "LinkedField",
        "name": "todo",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v4/*: any*/),
            "concreteType": "UpdateTodoMovePayload",
            "kind": "LinkedField",
            "name": "moveToCategory",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Todo",
                "kind": "LinkedField",
                "name": "todo",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v9/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TodoCategory",
                    "kind": "LinkedField",
                    "name": "category",
                    "plural": false,
                    "selections": [
                      (v10/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "TodoEditMoveToCategoryMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "TodoMutation",
        "kind": "LinkedField",
        "name": "todo",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v4/*: any*/),
            "concreteType": "UpdateTodoMovePayload",
            "kind": "LinkedField",
            "name": "moveToCategory",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Todo",
                "kind": "LinkedField",
                "name": "todo",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v9/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TodoCategory",
                    "kind": "LinkedField",
                    "name": "category",
                    "plural": false,
                    "selections": [
                      (v10/*: any*/),
                      (v7/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v7/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "88889971a25014d40c81f19055a3cd2e",
    "id": null,
    "metadata": {},
    "name": "TodoEditMoveToCategoryMutation",
    "operationKind": "mutation",
    "text": "mutation TodoEditMoveToCategoryMutation(\n  $todoId: ID!\n  $newCategoryId: ID!\n  $employeeId: ID\n) {\n  todo(todoId: $todoId, employeeId: $employeeId) {\n    moveToCategory(newCategoryId: $newCategoryId) {\n      todo {\n        categoryId\n        tags {\n          color\n          id\n          title\n        }\n        category {\n          tags {\n            id\n            color\n            title\n          }\n          id\n        }\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "2d83afc314cb873a1cd0783ff9193f1b";

export default node;
